// extracted by mini-css-extract-plugin
export default {"wrapper":"TopUpSepa_wrapper__bZl5p","text":"TopUpSepa_text__9jUpc","number":"TopUpSepa_number__t-tpC"};